<!-- 领奖用户列表 -->
<template>
  <div class="vhc-container">
    <!-- 标题栏 -->
    <pageTitle :pageTitle="$t('lang.k_248001')">
      <div slot="content">{{ $t('lang.k_248002') }}</div>
    </pageTitle>

    <!-- 顶部搜索栏 -->
    <div class="vhc-search-bar">
      <vh-button size="medium" type="primary" round @click="handleExport">
        {{ $t('lang.k_248003') }}
      </vh-button>
      <vh-button size="medium" type="text" round @click="handleSearch">
        {{ $t('lang.k_248004') }}
      </vh-button>
      <vh-input
        size="medium"
        round
        class="search-input"
        :placeholder="$t('lang.k_248005')"
        v-model="keyword"
        clearable
        v-clearEmoij
        @clear="handleSearch"
        @keyup.enter.native="handleSearch"
      >
        <i class="vh-icon-search vh-input__icon" slot="prefix" @click="handleSearch"></i>
      </vh-input>
    </div>

    <!-- 内容区 -->
    <div class="vhc-container__bd">
      <div class="vhc-main" v-loading="loading">
        <!-- 数据列表 -->
        <div class="vhc-main-content" v-if="!(dataList.length == 0 && !isSearch) && !loading">
          <vh-table ref="tableList" :data="dataList" class="vhc-main-table">
            <vh-table-column
              prop="winner_nickname"
              :label="$t('lang.k_248006')"
              min-width="160"
              :show-overflow-tooltip="true"
            />
            <vh-table-column prop="take_award_phone" :label="$t('lang.k_248007')" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.take_award_phone || '-' }}
              </template>
            </vh-table-column>
            <vh-table-column prop="winner_email" :label="$t('lang.k_248008')" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.winner_email || '-' }}
              </template>
            </vh-table-column>
            <vh-table-column :label="$t('lang.k_248009')" min-width="200">
              <template slot-scope="scope">
                <div class="award_box">
                  <vh-image
                    class="award_img_url"
                    fit="contain"
                    :src="scope.row.award_img_url"
                    :preview-src-list="[scope.row.award_img_url]"
                  ></vh-image>
                  <span class="award_name">{{ scope.row.award_name }}</span>
                </div>
              </template>
            </vh-table-column>
            <vh-table-column prop="push_time" :label="$t('lang.k_248010')" width="180">
              <template slot-scope="scope">
                {{ scope.row.push_at }}
              </template>
            </vh-table-column>
            <vh-table-column
              prop="winner_at"
              :label="$t('lang.k_248011')"
              width="160"
            ></vh-table-column>
            <template slot="empty">
              <noData :nullType="'search'" class="no_data" :text="$t('lang.k_248012')"></noData>
            </template>
          </vh-table>

          <SPagination
            :total="total || 0"
            :page-size="pagination.limit"
            :currentPage="pagination.pageNo"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></SPagination>
        </div>
        <noData
          v-else-if="!loading"
          :nullType="'nullData'"
          class="no_data"
          :text="$t('lang.k_248013')"
        ></noData>
      </div>
    </div>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle/index.vue';
  import noData from '@/views/PlatformModule/Error/nullPage.vue';
  import to from 'await-to-js';
  import { debounce } from 'lodash';

  export default {
    name: 'InteractiveRewardUserList',
    components: {
      PageTitle,
      noData
    },
    data() {
      return {
        webinarId: '', //活动id
        watchRewardId: '', //互动有礼id
        isInited: false, // 是否有成功的请求
        loading: false,
        isEmpty: true, // 是否完全空数据
        total: 0,
        keyword: '',
        dataList: [],
        // 分页参数
        pagination: {
          pos: 0,
          limit: 20,
          pageNo: 1
        },
        isSearch: false
      };
    },
    methods: {
      // 导出明细
      handleExport: debounce(async function () {
        const params = {
          webinar_id: this.webinarId,
          watch_gift_id: this.watchRewardId,
          keyword: this.keyword // 用户昵称
        };
        const [err, res] = await to(this.$fetch('exportWatchWinnerList', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_248014'));
          return;
        }
        this.$vhMessage.success(
          this.$t('lang.k_248015', [
            this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_248016')
          ])
        );
        this.$EventBus.$emit('saas_vs_download_change');
      }, 300),
      // 搜索
      handleSearch() {
        this.pagination.pos = 0;
        this.fetchData();
      },
      // 翻页事件
      handleCurrentChange(current) {
        this.pagination.pageNo = current; //当前页码
        this.pagination.pos = parseInt((current - 1) * this.pagination.limit);
        this.fetchData();
      },
      // 每页条数改变时触发
      handleSizeChange(limit) {
        this.pagination.limit = limit;
        this.pagination.pageNo = 1;
        this.pagination.pos = 0;
        this.fetchData();
      },
      // 请求数据
      fetchData: async function () {
        this.loading = true;
        this.keyword = this.keyword.trim();
        if (this.keyword) {
          this.isSearch = true;
        } else {
          this.isSearch = false;
        }
        const params = {
          webinar_id: this.webinarId,
          watch_gift_id: this.watchRewardId,
          keyword: encodeURI(this.keyword), // 用户昵称
          limit: this.pagination.limit,
          pos: this.pagination.pos
        };
        const [err, res] = await to(this.$fetch('getWatchWinnerList', params));
        this.loading = false;
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_248017'));
          return;
        }
        this.isInited = true;
        this.total = res.data.total || 0;
        this.dataList = res.data.list || [];
      }
    },
    created() {
      this.webinarId = this.$route.params.str || '';
      this.watchRewardId = this.$route.query.id || '';
    },
    mounted() {
      this.fetchData();
    }
  };
</script>
<style lang="less" scoped>
  .award_box {
    display: flex;
    align-items: center;
    .award_img_url {
      display: inline-block;
      width: 80px;
      height: 80px;
      border-radius: 4px;
      margin-right: 16px;
    }
    .award_name {
      width: 0;
      flex: 1;
    }
  }
  .no_data {
    height: 620px;
    margin-top: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
